<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="container" fluid>
      <v-card color="accent" elevation="6">
        <v-row style="margin: 10px">
          <v-col cols="10">
            <h3 class="warning-color">الصادر والوارد القديم</h3>
          </v-col>

          <v-col cols="2" style="text-align: left">
            <SearchOld style="display: inline-block" @clicked="onSearch" />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-container class="container" fluid>
      <v-card color="accent" elevation="6">
        <v-card-title class="warning-color">
          الصادرة
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="بحث" single-line hide-details solo></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
          <template v-slot:[`item.isActive`]="{ item }">
            <v-avatar size="20" color="success" v-if="item.isActive == 1"> </v-avatar>

            <v-avatar size="20" color="error" v-else> </v-avatar>
          </template>

          <template v-slot:[`item.index`]="{ index }">
            <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
          </template>
          <template v-slot:[`item.image`]="{ item }">
            <v-avatar size="32" v-if="item.image != null">
              <img :src="item.image" alt="John" />
            </v-avatar>

            <v-avatar size="32" color="indigo" v-else>
              <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import SearchOld from "../components/oldArchive/SearchOld.vue";
import DeleteOuter from "../components/outer/DeleteOuter.vue";
import Images from "../components/images.vue";
export default {
  components: {
    SearchOld,
    Images,
    DeleteOuter,
  },
  data: () => ({
    items: [],
    search: "",
    overlay: false,
    headers: [
      { text: "العدد", value: "idArchive" },
      { text: "رقم الكتاب", value: "archiveNumber" },
      { text: "تاريخ الكتاب", value: "archiveDateFormatted" },
      {
        text: "موضوع الكتاب",
        align: "start",
        sortable: false,
        value: "subject",
      },
      {
        text: "نوع الكتاب",
        align: "start",
        sortable: false,
        value: "archiveType",
      },
    ],
  }),

  methods: {
    onSearch(value) {
      console.log(value);
      this.items = value;
    },

    initialData() {
      let self = this;
      self.overlay = true;
      self.$http.get(`${self.$store.state.apiUrl}/searchArchive?archiveTypeId=1&yearStudyId=73`).then((res) => {
        console.log(res.data);
        self.items = res.data;
        self.overlay = false;
      });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.items.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.from.toLowerCase().includes(v));
        });
      } else {
        return this.items;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
